import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  AutoComplete,
  Col,
  Divider,
  // Dropdown,
  Input,
  Row,
  Modal,
  Tooltip,
  Image,
  Typography,
  Skeleton,
  Select,
  // Skeleton,
} from "antd";
import {
  FileTextOutlined,
  // DownOutlined,
  EditOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
  PlusOutlined,
  DeleteOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import "./index.css";
import { partySelectTabs, transactionsList } from "./data";
import customModalLogo from "../../assets/images/custom-field-banner.webp";
import { useHistory } from "react-router";
// import { Link } from "react-router-dom";
import { FcBusiness } from "react-icons/fc";
import PropTypes from "prop-types";
import { BiCreditCard } from "react-icons/bi";
import Transactions from "./transaction";
import LedgerStatement from "./ledgerStatement";
import ItemWiseReport from "./itemReport";
import { isEmpty } from "lodash";
import { loadParties, loadPartiesCategory } from "../../store/parties/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import api from "../../helpers";

const PartiesSelection = (props) => {
  const [loading, setLoading] = useState(false);
  const [partiesLoading, setPartiesLoading] = useState(false);
  const [ledgerLoading, setLedgerLoading] = useState(false);

  const dispatch = useDispatch();
  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const userInfoDetails = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const partyListId = { organizationId: userInfoDetails };

  //partys tabs

  //Props values from parties home
  const partyTabName =
    props.location && props.location.state
      ? props.location.state.data.partyName
      : "";
  const itemList =
    props.location && props.location.state ? props.location.state.itemLi : "";
  // const recordsMetaData = props.location.state
  //   ? props.location.state.metaData
  //   : "";
  const organizationId = props.location.state
    ? props.location.state.organizationId
    : "";
  const userId = props.location.state ? props.location.state.userId : "";

  // const partyTabId =
  //   props.location && props.location.state ? props.location.state.data._id : "";

  const partyData =
    props.location && props.location.state ? props.location.state.data : "";

  console.log(partyData, "partyData");

  const billingAddress =
    partyData && partyData.billingAddress.length > 0
      ? partyData.billingAddress[0]
      : "";
  const shippingAddress =
    partyData && partyData.shippingAddress.length > 0
      ? partyData.shippingAddress[0]
      : "";
  const billingAddressValues = billingAddress
    ? billingAddress.address1 +
      ", " +
      billingAddress.city +
      ", " +
      billingAddress.stateName +
      ", " +
      billingAddress.country +
      " - " +
      billingAddress.pincode
    : "";

  const shippingAddressValues = shippingAddress
    ? shippingAddress.address1 +
      ", " +
      shippingAddress.city +
      ", " +
      shippingAddress.stateName +
      ", " +
      shippingAddress.country +
      " - " +
      shippingAddress.pincode
    : "";
  console.log(billingAddressValues, "billingAddressValues");
  //api loader
  useEffect(() => {
    dispatch(loadParties(partyListId));
    setPartiesLoading(true);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setPartiesLoading(false);
    }, 2000);
    dispatch(loadPartiesCategory(itemList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const { parties_list = [], category_list = [] } = useSelector(
    (state) => state.Parties
  );

  const categoryOptions =
    category_list.length > 0
      ? category_list.map((c) => {
          return {
            label: c.categoryName,
            shortCode: c.shortCode,
            value: c._id,
          };
        })
      : [];
  //state data section
  const [partyDetailsData, setPartyDetailsData] = useState("");
  const [deletePartyModal, setDeletePartyModal] = useState(false);
  const [deletedPartyId, setDeletedPartyId] = useState("");
  const [mouseEnter, setMouseEnter] = useState(false);
  const [partiesTab, setPartiesTab] = useState(partyTabName);
  const [partiesSelectedTabs, setPartiesSelectedTabs] = useState("Profile");
  const [selectedValue, setSelectedValue] = useState(partyTabName);
  const [transactionType, setTransactionType] = useState([]);

  const [pageRouting, setPageRouting] = useState(false);
  const history = useHistory();

  const [partiesRows, setPartiesRows] = useState([
    {
      partyName: "",
      partyNameValue: "",
      partyCode: "",
      billingAddress: "",
      _id: "",
      createdAt: "",
      createdBy: "",
      creditBalance: "",
      currentBalance: "",
      creditLimit: "",
      creditPeriod: "",
      currencyId: "",
      currencyName: "",
      displayName: "",
      email: "",
      gstPercentageId: "",
      gstPercentageName: "",
      gstTypeName: "",
      mobileNo: "",
      openingBalance: "",
      openingbalanceType: "",
      panNumber: "",
      gstIn: "",
      placeofSupply: "",
      shippingAddress: "",
      status: "",
      updatedAt: "",
    },
  ]);

  const partiesDataTable =
    parties_list && parties_list.length > 0
      ? parties_list.map((data, index) => {
          const billingAddress =
            data.billingAddress.length > 0 ? data.billingAddress[0] : "";
          const shippingAddress =
            data.shippingAddress.length > 0 ? data.shippingAddress[0] : "";
          const billingAddressValues = billingAddress
            ? billingAddress.address1 +
              ", " +
              billingAddress.city +
              ", " +
              billingAddress.stateName +
              ", " +
              billingAddress.country +
              " - " +
              billingAddress.pincode
            : "";
          console.log(billingAddressValues, "billingAddressValues");
          const shippingAddressValues = shippingAddress
            ? shippingAddress.address1 +
              ", " +
              shippingAddress.city +
              ", " +
              shippingAddress.stateName +
              ", " +
              shippingAddress.country +
              " - " +
              shippingAddress.pincode
            : "";
          console.log(shippingAddressValues, "shippingAddressValues");

          return {
            index: index + 1,
            partyName: data.partyName,
            partyNameValue: data.partyName,
            billingAddress:
              data.billingAddress && billingAddressValues
                ? billingAddressValues
                : "",
            _id: data._id,
            createdAt: data.createdAt,
            createdBy: data.createdBy,
            creditBalance:
              data.creditBalance && data.creditBalance.toLocaleString("en-IN"),
            currentBalance:
              data.currentBalance &&
              data.currentBalance.toLocaleString("en-IN"),
            creditLimit:
              data.creditLimit && data.creditLimit.toLocaleString("en-IN"),
            creditPeriod: data.creditPeriod,
            currencyId: data.currencyId,
            currencyName: data.currencyName,
            displayName: data.displayName,
            email: data.email,
            gstPercentageId: data.gstPercentageId,
            gstPercentageName: data.gstPercentageName,
            gstTypeName: data.gstTypeName,
            mobileNo: data.mobileNo,
            openingBalance: data.openingBalance,
            openingbalanceType: data.openingbalanceType,
            panNumber: data.panNumber,
            placeofSupply: data.placeofSupply,
            shippingAddress:
              data.shippingAddress && shippingAddressValues
                ? shippingAddressValues
                : "",
            status: data.status,
            updatedAt: data.updatedAt,
          };
        })
      : [];

  useEffect(() => {
    if (
      partiesDataTable &&
      partiesDataTable.length > 0 &&
      partiesTab === partyTabName
    ) {
      setPartiesRows(partiesDataTable);
    } else if (partiesTab === partyDetailsData && partyDetailsData.partyName) {
      setPartiesRows(partiesDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partiesTab, parties_list]);

  useEffect(() => {
    setPartiesTab(partyTabName);
    setSelectedValue(partyTabName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Search parties
  const [search, setSearch] = useState("");

  const handleSearch = (event) => {
    const filteredRows = partiesDataTable
      .filter((row) =>
        row.partyNameValue
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setPartiesRows(filteredRows);
    setPartiesLoading(true);
    setTimeout(() => {
      setPartiesLoading(false);
    }, 2000);
  };

  //Custom Fields State values
  const [customFields, setCustomFields] = useState(false);
  // const [customFieldsAdd, setCustomFieldsAdd] = useState(false);
  const [pageRender, setPageRender] = useState(false);

  const handleOk = () => {
    setCustomFields(false);
  };
  const handleCancel = () => {
    setCustomFields(false);
  };

  const [customFieldsData, setCustomFieldsData] = useState([
    {
      fieldName: "",
    },
  ]);

  const addCustomFields = () => {
    setCustomFieldsData([
      ...customFieldsData,
      {
        fieldName: "",
      },
    ]);
    // setCustomFieldsAdd(true);
    setPageRender(!pageRender);
  };

  const removeCustomFields = (index) => {
    const array = customFieldsData;
    if (index !== 0) {
      if (index > -1) {
        array.splice(index, 1);
      }
    }
    setPageRender(!pageRender);
  };

  const handleCustomFieldsChange = (e, name, index) => {
    var fieldList = customFieldsData;
    if (name === "fieldName") {
      fieldList[index][name] = e.target.value;
      setCustomFieldsData(fieldList);
      setPageRender(!pageRender);
    }
  };

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  //category api integrations
  const deleteParty = () => {
    setIsButtonDisabled(true);
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 4000);
    const partiesList = {
      organizationId: userInfoDetails,
      partyId: !isEmpty(partyDetailsData)
        ? partyDetailsData._id
        : partyData._id,
      deletedBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
    };
    api
      .post("/org/deleteparty", partiesList)
      .then((res) => {
        dispatch(loadParties(partyListId));
        setDeletedPartyId(partiesList.partyId);
        setDeletePartyModal(false);
        toast.error("Parties Deleted Successfully");
        setTimeout(() => {
          history.push("/parties");
        }, 1300);
        return res.data;
      })
      .catch((error) => {
        const errorMsg =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.error) ||
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message);
        toast.error(errorMsg || "There is an issue while delete the items");
        Promise.reject(error);
      });
  };

  useEffect(() => {
    if (!isEmpty(deletedPartyId)) {
      const partiesFilteredData =
        partiesDataTable.length > 0
          ? partiesDataTable.filter((data) => data._id !== deletedPartyId)
          : [];
      const partiesRemainingData =
        partiesFilteredData && partiesFilteredData.length > 0
          ? partiesFilteredData[0]
          : "";
      const partiesRemainingId =
        partiesFilteredData && partiesFilteredData.length > 0
          ? partiesFilteredData[0].partyName
          : "";
      console.log(partiesFilteredData, partiesRemainingId, "partiesId");
      setPartiesTab(partiesRemainingId);
      setSelectedValue(partiesRemainingData);
      setPartyDetailsData(partiesRemainingData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deletedPartyId]);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Parties | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <Row>
            <Col span={5} className="border border-r-1 border-y-0 border-l-0">
              <Row className="flex justify-between mb-4 mt-4">
                <Col span={24} className="pr-3 pl-4">
                  <div className="flex">
                    <Tooltip
                      rootClassName="text-[10px]"
                      title="Search by phone or name"
                      placement="bottom"
                    >
                      <AutoComplete
                        style={{
                          width: 170,
                          marginRight: "10px",
                          fontFamily: "Poppins",
                        }}
                      >
                        <Input.Search
                          size="large"
                          placeholder="Search Party"
                          style={{
                            fontFamily: "Poppins",
                          }}
                          name="search"
                          value={search}
                          onChange={(e) => handleSearch(e)}
                        />
                      </AutoComplete>
                    </Tooltip>
                  </div>
                </Col>
                <Col
                  span={24}
                  onMouseEnter={() => setMouseEnter(true)}
                  onMouseLeave={() => setMouseEnter(false)}
                  className={mouseEnter ? "parties-menu-main-card" : ""}
                >
                  <Row className="pl-5 pr-5 mt-6 mb-5">
                    {partiesRows.map((data) => {
                      return (
                        <Col span={24} key={data.key} className="mb-4">
                          {partiesLoading ? (
                            <Skeleton.Input
                              style={{
                                width: "60px",
                                height: "60px",
                              }}
                              active={true}
                              size={"large"}
                              // block={true}
                            ></Skeleton.Input>
                          ) : (
                            <div
                              className={
                                partiesTab === data.partyName
                                  ? "poppins parties-selection-card parties-selection-cards border rounded-md"
                                  : "poppins parties-selection-card border rounded-md"
                              }
                              onClick={() => {
                                setPartiesTab(data.partyName);
                                setSelectedValue(data);
                                setPartyDetailsData(data);
                                setLedgerLoading(true);
                                setTimeout(() => {
                                  setLedgerLoading(false);
                                }, 2000);
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "12px",
                                  display: "flex",
                                  color: "black",
                                }}
                              >
                                <h2>{data.partyName}</h2>
                              </div>
                              <div className="mt-1 flex justify-between">
                                <h1 className="font-semibold text-[14px]">
                                  {data.currentBalance
                                    ? "₹ " + data.currentBalance
                                    : "₹ " + 0}
                                </h1>
                                <p>
                                  {data.openingbalanceType === "To Pay" ? (
                                    <ArrowUpOutlined className="text-[red]" />
                                  ) : (
                                    <ArrowDownOutlined className="text-[green]" />
                                  )}
                                </p>
                              </div>
                            </div>
                          )}
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col span={19}>
              <Row>
                <Col span={24}>
                  <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-4">
                    <div className="flex">
                      <ArrowLeftOutlined
                        onClick={() => setPageRouting(true)}
                        className="font-bold text-[18px]"
                      />
                      <h1 className="text-[20px] ml-2 mt-2 font-semibold">
                        {partyData && isEmpty(partyDetailsData)
                          ? partyData.partyName
                          : partyDetailsData
                          ? partyDetailsData.partyName
                          : selectedValue}
                      </h1>
                    </div>

                    <div className="flex">
                      <div className="rounded-md">
                        <Select
                          style={{
                            width: 180,
                            height: 40,
                            border: "none",
                          }}
                          rootClassName="border-none font-semibold"
                          placeholder="Create Invoice"
                          value={transactionType}
                          onChange={(e) => setTransactionType(e)}
                          //   dropdownRender={(menu) => (
                          //     <p className="border border-b-1 border-x-0 border-t-0">
                          //       {menu}
                          //     </p>
                          //   )}

                          options={transactionsList}
                        />
                      </div>
                      <Tooltip
                        title="Edit Party Details"
                        placement="left"
                        rootClassName="text-[10px]"
                      >
                        <div
                          onClick={() => {
                            history.push({
                              pathname: "/add-parties",
                              state: {
                                partyData: !isEmpty(partyDetailsData)
                                  ? partyDetailsData
                                  : partyData
                                  ? partyData
                                  : "",
                                organizationId: organizationId,
                                userId: userId,
                                itemList: itemList,
                                categoryOptions: categoryOptions,
                              },
                            });
                          }}
                          className="border flex rounded-md justify-between  pl-3 pr-2 pt-2 pb-2 ml-3  cursor-pointer"
                        >
                          <EditOutlined className="text-[16px] pr-3" /> Edit
                        </div>
                      </Tooltip>
                      <Tooltip
                        title="Delete This Party"
                        placement="bottom"
                        rootClassName="text-[10px]"
                      >
                        <div
                          onClick={() => setDeletePartyModal(true)}
                          className="border border-1 border-red-200 text-[red] rounded-md ml-3 p-2.5 cursor-pointer"
                        >
                          <DeleteOutlined />
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </Col>

                <Col span={24}>
                  <Row className="border border-b-1 border-t-0 border-x-0 flex flex-row ml-4 mr-4 pr-5 mt-6 mb-5">
                    {partySelectTabs.map((data) => {
                      return (
                        <div
                          className={
                            partiesSelectedTabs === data.label
                              ? "p-2 font-semibold parties-selection-data-tabs parties-selection-tabs"
                              : "p-2 parties-selection-data-tabs"
                          }
                          key={data.key}
                          onClick={() => {
                            setPartiesSelectedTabs(data.label);
                            setLoading(true);
                            setTimeout(() => {
                              setLoading(false);
                            }, 2000);
                          }}
                        >
                          <div
                            style={{
                              fontSize: "13px",
                              display: "flex",
                              color:
                                partiesSelectedTabs === data.label
                                  ? "#8400ff"
                                  : "#667085",
                            }}
                          >
                            <p className={data.key !== 1 ? "mt-[1px]" : ""}>
                              {data.icon}
                            </p>
                            <h2 className={"ml-2"}>{data.label}</h2>
                          </div>
                        </div>
                      );
                    })}
                  </Row>
                  <Row
                    className={
                      partiesSelectedTabs === "Transactions" ||
                      partiesSelectedTabs === "Ledger (Statement)"
                        ? "pl-4 pr-4"
                        : "pl-4 pr-4 add-party-select-main"
                    }
                  >
                    {partiesSelectedTabs === "Transactions" ? (
                      <Transactions
                        partyId={
                          !isEmpty(partyDetailsData)
                            ? partyDetailsData._id
                            : partyData._id
                        }
                        organizationId={userInfoDetails}
                      />
                    ) : partiesSelectedTabs === "Ledger (Statement)" ? (
                      <LedgerStatement
                        partyId={
                          !isEmpty(partyDetailsData)
                            ? partyDetailsData._id
                            : partyData._id
                        }
                        ledgerLoading={ledgerLoading}
                        partyName={partiesTab}
                        organizationId={userInfoDetails}
                      />
                    ) : partiesSelectedTabs === "Item Wise Report" ? (
                      <ItemWiseReport
                        partyId={
                          !isEmpty(partyDetailsData)
                            ? partyDetailsData._id
                            : partyData._id
                        }
                        categoryOptions={categoryOptions}
                        organizationId={userInfoDetails}
                      />
                    ) : (
                      // Profile Details
                      <Col span={24}>
                        <Row>
                          <Col span={12} className="pr-4">
                            <Row className="mb-4 border rounded-md border-1 border-lightgray-200">
                              <Col
                                span={24}
                                className="border border-b-1 border-x-0 border-t-0 "
                              >
                                <div className="p-2 bg-[#e5e5e5] party-label">
                                  <p className="text-[12px]">
                                    <FileTextOutlined className="mr-3" />
                                    General Details
                                  </p>
                                </div>
                              </Col>
                              {loading ? (
                                <Skeleton
                                  style={{
                                    marginRight: "5px",
                                    width: "100%",
                                    height: "170px",
                                    padding: "10px",
                                  }}
                                  active={true}
                                  size={"large"}
                                  // block={true}
                                ></Skeleton>
                              ) : (
                                <>
                                  <Col span={12} className="pb-4 pl-4 pr-4">
                                    <div className="party-label mt-2">
                                      <h1 className="mb-1">Party Name</h1>
                                      <p className="font-semibold">
                                        {partyData && isEmpty(partyDetailsData)
                                          ? partyData.partyName
                                          : partyDetailsData
                                          ? partyDetailsData.partyName
                                          : selectedValue}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="pb-4 pl-4 pr-4">
                                    <div className="party-label mt-2">
                                      <h1 className="mb-1">Display Name</h1>
                                      <p className="font-semibold">
                                        {" "}
                                        {partyData && isEmpty(partyDetailsData)
                                          ? partyData.displayName
                                          : partyDetailsData
                                          ? partyDetailsData.displayName
                                          : "--"}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="pl-4 pr-4">
                                    <div className="party-label mt-2">
                                      <h1 className="mb-1">Mobile Number</h1>
                                      <p className="font-semibold">
                                        {" "}
                                        {partyData && isEmpty(partyDetailsData)
                                          ? partyData.mobileNo
                                          : partyDetailsData
                                          ? partyDetailsData.mobileNo
                                          : "--"}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="pl-4 pr-4">
                                    <div className="party-label mt-2">
                                      <h1 className="mb-1">Credit Limit</h1>
                                      <p className="font-semibold">
                                        {partyData && isEmpty(partyDetailsData)
                                          ? partyData.creditLimit &&
                                            partyData.creditLimit.toLocaleString(
                                              "en-IN"
                                            )
                                          : partyDetailsData
                                          ? partyDetailsData.creditLimit &&
                                            partyDetailsData.creditLimit.toLocaleString(
                                              "en-IN"
                                            )
                                          : "--"}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={24} className="pl-4 pr-4">
                                    <div className="party-label  mt-2">
                                      <h1 className="mb-1">Email</h1>
                                      <p className="font-semibold">
                                        {" "}
                                        {partyData && isEmpty(partyDetailsData)
                                          ? partyData.email
                                          : partyDetailsData &&
                                            !isEmpty(partyDetailsData.email)
                                          ? partyDetailsData.email
                                          : "--"}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={24} className="pl-4 pr-4 pb-4">
                                    <div className="party-label  mt-2">
                                      <h1 className="mb-1">Opening Balance</h1>
                                      <p className="font-semibold">
                                        ₹{" "}
                                        {partyData && isEmpty(partyDetailsData)
                                          ? partyData.openingBalance
                                          : partyDetailsData
                                          ? partyDetailsData.openingBalance
                                          : "--"}
                                      </p>
                                    </div>
                                  </Col>
                                </>
                              )}
                            </Row>
                          </Col>
                          <Col span={12} className="">
                            {" "}
                            <Row className="mb-2 border rounded-md border-1 border-lightgray-200">
                              <Col
                                span={24}
                                className="border border-b-1 border-x-0 border-t-0 "
                              >
                                <div className="p-2 bg-[#e5e5e5] party-label">
                                  <p className="text-[12px] flex">
                                    <FcBusiness size={14} className="mr-3" />
                                    Business Details
                                  </p>
                                </div>
                              </Col>
                              {loading ? (
                                <Skeleton
                                  style={{
                                    marginRight: "5px",
                                    width: "100%",
                                    height: "170px",
                                    padding: "10px",
                                  }}
                                  active={true}
                                  size={"large"}
                                  // block={true}
                                ></Skeleton>
                              ) : (
                                <>
                                  <Col span={12} className="pb-4 pl-4 pr-4">
                                    <div className="party-label mt-2">
                                      <h1 className="mb-1">GSTIN</h1>
                                      <p className="font-semibold">
                                        {partyData && isEmpty(partyDetailsData)
                                          ? partyData.gstIn
                                          : partyDetailsData
                                          ? partyDetailsData.gstIn
                                          : "--"}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="pb-4 pl-4 pr-4">
                                    <div className="party-label mt-2">
                                      <h1 className="mb-1">PAN Number</h1>
                                      <p className="font-semibold">
                                        {partyData && isEmpty(partyDetailsData)
                                          ? partyData.panNumber
                                          : partyDetailsData
                                          ? partyDetailsData.panNumber
                                          : "--"}
                                      </p>
                                    </div>
                                  </Col>

                                  <Col span={24} className="pl-4 pr-4">
                                    <div className="party-label  mt-2">
                                      <h1 className="mb-1">Billing Address</h1>
                                      <p className="font-semibold">
                                        {partyData && isEmpty(partyDetailsData)
                                          ? billingAddressValues
                                          : partyDetailsData
                                          ? partyDetailsData.billingAddress
                                          : "--"}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={24} className="pl-4 pr-4 pb-4">
                                    <div className="party-label  mt-2">
                                      <h1 className="mb-1">Shipping Address</h1>
                                      <p className="font-semibold">
                                        {partyData && isEmpty(partyDetailsData)
                                          ? shippingAddressValues
                                          : partyDetailsData
                                          ? partyDetailsData.shippingAddress
                                          : "--"}
                                      </p>
                                    </div>
                                  </Col>
                                </>
                              )}
                            </Row>
                          </Col>
                          <Col span={12} className="pr-4 mb-10">
                            {" "}
                            <Row className="border rounded-md border-1 border-lightgray-200">
                              <Col
                                span={24}
                                className="border border-b-1 border-x-0 border-t-0 "
                              >
                                <div className="p-2 bg-[#e5e5e5] party-label">
                                  <p className="text-[12px] flex">
                                    <BiCreditCard size={14} className="mr-3" />
                                    Credit Details
                                  </p>
                                </div>
                              </Col>
                              {loading ? (
                                <Skeleton
                                  style={{
                                    marginRight: "5px",
                                    width: "100%",
                                    height: "170px",
                                    padding: "10px",
                                  }}
                                  active={true}
                                  size={"large"}
                                  // block={true}
                                ></Skeleton>
                              ) : (
                                <>
                                  <Col span={12} className="pb-4 pl-4 pr-4">
                                    <div className="party-label mt-2">
                                      <h1 className="mb-1">Credit Period</h1>
                                      <p className="font-semibold">
                                        {partyData && isEmpty(partyDetailsData)
                                          ? partyData.creditPeriod
                                          : partyDetailsData
                                          ? partyDetailsData.creditPeriod
                                          : "--"}{" "}
                                        Days
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="pb-4 pl-4 pr-4">
                                    <div className="party-label mt-2">
                                      <h1 className="mb-1">Credit Limit</h1>
                                      <p className="font-semibold">
                                        ₹{" "}
                                        {partyData && isEmpty(partyDetailsData)
                                          ? partyData.creditLimit &&
                                            partyData.creditLimit.toLocaleString(
                                              "en-IN"
                                            )
                                          : partyDetailsData
                                          ? partyDetailsData.creditLimit &&
                                            partyDetailsData.creditLimit.toLocaleString(
                                              "en-IN"
                                            )
                                          : "--"}{" "}
                                      </p>
                                    </div>
                                  </Col>
                                </>
                              )}
                            </Row>
                          </Col>
                          <Col span={12} className="mb-10 mt-[-20px]">
                            {" "}
                            <Row className="border rounded-md border-1 border-lightgray-200">
                              <Col
                                span={24}
                                className="border border-b-1 border-x-0 border-t-0 "
                              >
                                <div className="flex justify-between p-2 bg-[#fbf6ed] party-label">
                                  <div className="">
                                    <h1 className="text-[13px]">
                                      Custom Fields
                                    </h1>
                                    <p className="text-[14px]">
                                      Now you can add custom item fields like
                                      Colour, Size, ID Number, etc.
                                    </p>
                                  </div>
                                  <PlusOutlined
                                    onClick={() => setCustomFields(true)}
                                    className="bg-[white] text-[black] text-[14px] mt-1 rounded-md  p-3 h-[40px] w-[40px]"
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </Col>

            {/* Parties input section with bulk actions */}
          </Row>
        </Col>
      </Row>

      {/* Custom fields modal */}
      <Modal
        open={customFields}
        title="Add Custom Fields"
        onOk={handleOk}
        closeIcon
        maskClosable={false}
        okText={"Save"}
        okButtonProps={{
          disabled: customFieldsData.length > 0 ? false : true,
        }}
        onCancel={handleCancel}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        )}
      >
        <Divider
          style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
        />
        <div className="w-[110%] ml-[-23.5px] mt-[-24px] mb-4">
          <Image src={customModalLogo} />
        </div>
        <div>
          <Typography className="mb-2">Field Name</Typography>
          {customFieldsData.map((data, index) => {
            return (
              <div key={index} className="mb-2">
                <div className="flex justify-between mb-[10px]">
                  <Input
                    name="fieldName"
                    value={data.fieldName}
                    placeholder="Enter Custom Field name"
                    className="w-[90%]"
                    onChange={(e) =>
                      handleCustomFieldsChange(e, "fieldName", index)
                    }
                  />
                  <DeleteOutlined
                    onClick={() => removeCustomFields(index)}
                    type="primary"
                    className="ml-3 border rounded-md p-2 text-[red] cursor-pointer"
                    size={"large"}
                  />{" "}
                </div>
              </div>
            );
          })}
        </div>
        {/* ) : (
            ""
          )} */}

        <Row
          onClick={() => addCustomFields()}
          className="w-[100%] mt-2 bg-gray-50 p-2 border border-dashed border-blue-400 pl-5 pr-5 mt-3 mb-3"
        >
          <h1 className="cursor-pointer text-[14px] text-[#084d7b] font-semibold">
            {" "}
            <PlusOutlined /> Add Custom Field
          </h1>
        </Row>
        <Divider
          style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
        />
      </Modal>
      <Modal
        open={pageRouting}
        onOk={() => {
          setPageRouting(false);
          history.push("/parties");
        }}
        closeIcon
        maskClosable={false}
        rootClassName="p-15 h-[300px]"
        okText={"Yes, Leave"}
        cancelText={"No, Stay"}
        onCancel={() => setPageRouting(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <div className="mr-3">
              <OkBtn />
            </div>
            <CancelBtn />
          </div>
        )}
        width={500}
      >
        <div className="text-center w-[100%]">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to leave this page?
          </h1>
          <p className="text-center text-[14px] mt-2">
            All unsaved changes will be lost!
          </p>
        </div>
      </Modal>

      {/* Delete item modal */}

      <Modal
        open={deletePartyModal}
        onOk={() => {
          deleteParty();
        }}
        closeIcon
        maskClosable={false}
        okText={`Delete Party`}
        cancelText={"Cancel"}
        okType="danger"
        okButtonProps={{
          disabled: isButtonDisabled ? true : false,
        }}
        onCancel={() => setDeletePartyModal(false)}
        height={300}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <CancelBtn />
            <div className="ml-3">
              <OkBtn />
            </div>
          </div>
        )}
      >
        <div className="text-center w-[100%] p-7">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to delete these party?
          </h1>
          <p className="text-center text-[14px] mt-2">
            The selected party will be deleted from the party Inventory. Once
            deleted you will not be able to restore these party.
          </p>
        </div>
      </Modal>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

PartiesSelection.propTypes = {
  location: PropTypes.any,
};

export default PartiesSelection;
